import { FormattedMessage } from 'react-intl';

import { useNoticeSectionStyles } from './NoticeSection.styles';

export default function NoticeSection() {
  const { styles } = useNoticeSectionStyles();
  return (
    <div className={styles.notice}>
      <span className="text-uppercase" style={{ fontWeight: 700 }}>
        <FormattedMessage id="book.newQuote.notice" />
      </span>
      <br />
      <span style={{ fontWeight: 700 }}>
        <FormattedMessage id="book.newQuote.quotesValid" />
      </span>
      <br />
      <FormattedMessage id="book.newQuote.quotesAreBased" />
      <br />
      <span style={{ fontWeight: 700 }}>
        <FormattedMessage id="book.newQuote.customersShould" />
      </span>
      <br />
      <FormattedMessage id="book.newQuote.notAllPotential" />
    </div>
  );
}
